import React, { useState, useEffect } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import { Modal, Button, Form } from 'react-bootstrap';
import dayjs from 'dayjs';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useLoading } from "../Utils/LoadingContext";
import EmployeeProcessService from '../services/EmployeeProcessService';
import LeaveProcessService from "../services/LeaveProcessService";

const PunchCalendar = () => {
  const [events, setEvents] = useState([]);
  const [userCode, setUserCode] = useState('');
  const [month, setMonth] = useState(dayjs().format('YYYY-MM'));
  const [selectedDate, setSelectedDate] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [inTime, setInTime] = useState('');
  const [outTime, setOutTime] = useState('');
  const [systemIn, setSystemIn] = useState('');
  const [statusN, setStatusN] = useState('');
  const [systemOut, setSystemOut] = useState('');
  const [shiftName, setShiftName] = useState(''); // 👈 added shift state
  const [calendarKey, setCalendarKey] = useState(0);
  const [calendarDate, setCalendarDate] = useState(dayjs().format('YYYY-MM-DD'));
  const [searchText, setSearchText] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [comment, setComment] = useState('');
  const [leaveBalance, setLeaveBalance] = useState([]);
  const [workingHours, setWorkingHours] = useState({
    expected: "0 HH",
    actual: "0 HH",
    deducted: "0 HH"
  });

  const [attendanceStats, setAttendanceStats] = useState({
    present: 0,
    paidLeave: 0,
    weeklyOff: 0,
    holidays: 0,
    absent: 0,
    unpaidLeave: 0,
    deductionLeave: 0,
    deductionPD: 0,
    arrears: 0,
    insentive: 0,
    totalPaidDays: 0,
    isSandwich: 0
  });
  useEffect(() => {
    if (userCode && month) {
      fetchPunchData(userCode, month);
      loadLeaveBalance(userCode, month);
      loadAttendanceDetails(); // 🔥 add this line
    }
  }, [userCode, month]);

  const getLeaveMMYY = () => {
    if (!month) return "";
    const [year, mon] = month.split("-");
    return `${mon}${year}`;
  };


  const loadAttendanceDetails = async () => {
    try {
      if (!userCode || !month) return;

      setLoading(true);

      const formData = new FormData();
      formData.append("ManagerCode", userCode);
      formData.append("EmployeeCode", userCode);
      formData.append("LeaveMMYY", getLeaveMMYY());
      formData.append("Type", "GetEmployeeAttendanceDetails");

      const response = await LeaveProcessService.getEmployeeAttendanceDetails(formData);
debugger;
      if (response.success) {
        const data = response.data[0];
        debugger;
        setAttendanceStats({
          present: data.present || 0,
          paidLeave: data.paidLeave || 0,
          weeklyOff: data.weeklyOff || 0,
          holidays: data.holidays || 0,
          absent: data.absent || 0,
          unpaidLeave: data.unpaidLeave || 0,
          deductionLeave: data.deductionLeave || 0,
          deductionPD: data.deductionPD || 0,
          arrears: data.arrears || 0,
          insentive: data.insentive || 0,
          totalPaidDays: data.totalPaidDays || 0,
          isSandwich: data.isSandwich || 0
        });

        setWorkingHours({
          expected: (data.expected || 0) + " HH",
          actual: (data.actual || 0) + " HH",
          deducted: (data.deducted || 0) + " HH"
        });

      }

      else {
        clearDashboardData();
        const message = response.errorMessage || 'Submission failed. Please try again.';
        //alert(message);
      }
    } catch (error) {
      const message = error?.message || 'Unexpected error occurred.';
      alert(message);
      console.error("Unhandled error:", message);
    } finally {
      setLoading(false);
    }
  }

  const handleInputChange = async (e) => {
    const value = e.target.value;
    setSearchText(value);

    if (!value) {
      setSuggestions([]);
      setShowSuggestions(false);
      return;
    }
    try {
      const response = await EmployeeProcessService.getEmployeeSearch(value);
      if (response.data.statusCode === 200) {
        setSuggestions(response.data.result);
        setShowSuggestions(true);
      } else {
        setSuggestions([]);
        setShowSuggestions(false);
      }
    } catch (error) {
      console.error('Error fetching suggestions:', error);
      setSuggestions([]);
      setShowSuggestions(false);
    }
  };

  const handleSelectSuggestion = (emp) => {
    const label = `${emp.employeeName} (${emp.employeeCode})`;
    setSearchText(label);
    setUserCode(emp.employeeCode);
    setSuggestions([]);
    setShowSuggestions(false);
  };

  const fetchPunchData = async (userCodeParam, monthParam) => {
    try {
      const response = await EmployeeProcessService.getEmployeePunch(userCodeParam, monthParam);
      if (response.success && response.data.statusCode === 200) {

        const rawData = response.data.result;

        const calendarEvents = rawData.map(item => {
          const date = dayjs(item.punchDates).format('YYYY-MM-DD');
          const status = item.status;
          const hours = parseFloat(item.hoursWorked || '0');

          let backgroundColor = '#fff'; // Default Absent (Red)
          let textColor = '#fff';
          let title = 'NO Data';

          if (status === 'PP' || status === 'OD' || status === 'AR') {
            backgroundColor = '#28a745'; // Green = Present
            title = `${hours.toFixed(2)} hrs`;
          } else if (status === 'AP' || status === 'PA') {
            backgroundColor = 'orange'; // Orange = Half Day
            title = `Half (${hours.toFixed(2)} hrs)`;
          } else if (status === 'WO') {
            backgroundColor = 'silver'; // Light Gray = Week Off
            title = 'Week Off';
          } else if (status === 'HO') {
            backgroundColor = 'purple'; // Blue  = Holiday
            title = 'Holiday';
          } else if (status === 'AA') {
            backgroundColor = '#dc3545'; // Red = Absent
            title = 'Absent';
          }
          else if (status === 'PL' || status === 'CL' || status === 'ACL' || status === 'CLA' || status === 'PCL' || status === 'CLP') {
            backgroundColor = 'blue'; // Orange = Half Day
            title = `${status}`;
          }

          return {
            title,
            date,
            backgroundColor,
            textColor,
            extendedProps: {
              punchINTime: item.punchINTime,
              punchOUTTime: item.punchOUTTime,
              shiftName: item.shiftName, // 👈 include shift
              status: status
            }
          };
        });

        setEvents(calendarEvents);
        setCalendarKey(prev => prev + 1);
        setCalendarDate(dayjs(monthParam).startOf('month').format('YYYY-MM-DD'));

      }
      else {
        const message = response.errorMessage || 'Submission failed. Please try again.';
        alert(message);
      }
    } catch (error) {
      const message = error?.message || 'Unexpected error occurred.';
      alert(message);
      console.error("Unhandled error:", message);
    } finally {
      setLoading(false);
    }
  }

  /* ================= LEAVE BALANCE ================= */

  const loadLeaveBalance = async (userCodeParam, monthParam) => {
    try {
      const formData = new FormData();

      formData.append("EmployeeCode", userCodeParam);
      formData.append("Type", "GetLeave");
      formData.append("LeaveMMYY", monthParam);

      const res = await LeaveProcessService.getEmployeeDashBoard(formData);

      if (res.data.statusCode === 200) {

        setLeaveBalance(
          res.data.result.map(x => ({
            leaveCode: x.leaveCode,
            totalBalance: x.availableBalance
          }))
        );

      }
    }
    catch (error) {
      const message = error?.message || 'Unexpected error occurred.';
      // toast.error(message);
      console.error("Unhandled error:", message);
      setLoading(false);
    } finally {
      setLoading(false);
    }

  };

  const handleDateClick = (arg) => {
    const event = events.find(e => e.date === arg.dateStr);
    const status = event?.extendedProps?.status;
    // ✅ If status is blank/null/undefined then do not open modal
    if (!status || status.trim() === '') {
      alert('Please Check DOJ.');
      return;
    }
    if (status === 'A' || !status) {
      setSystemIn('N/A');
      setSystemOut('N/A');
      setStatusN('N/A');
    } else {
      debugger;
      setSystemIn(event?.extendedProps?.punchINTime || 'N/A');
      setSystemOut(event?.extendedProps?.punchOUTTime || 'N/A');
      setStatusN(event?.extendedProps?.status || 'N/A');
    }

    setShiftName(event?.extendedProps?.shiftName || 'N/A'); // 👈 set shift in modal
    setSelectedDate(arg.dateStr);
    setInTime('');
    setOutTime('');
    setShowModal(true);
  };

  const handleUpdate = async () => {
    try {
      // ✅ Shift validation
      if (!shiftName || shiftName === "N/A") {
        alert("Shift is not assigned. Cannot update punch.");
        return;
      }
      if (!comment || comment.trim() === '') {
        alert("Please enter comment");
        return;
      }
      const formData = new FormData();
      formData.append('UserCode', userCode);
      formData.append('PunchDates', selectedDate);

      // Only append if inTime has a value
      if (inTime && inTime.trim() !== '') {
        formData.append('PunchIN', `${inTime}:00`);
      }

      // Only append if outTime has a value
      if (outTime && outTime.trim() !== '') {
        formData.append('PunchOUT', `${outTime}:00`);
      }
      // ✅ Add Comment
      formData.append('Comment', comment || '');

      const response = await EmployeeProcessService.setEmployeePunch(formData);

      if (response.success && response.data.statusCode === 200) {
        const msg = response.data.result;
        alert(msg);
      }
    } catch (error) {
      console.error("Error updating punch data", error);
    } finally {
      setShowModal(false);
      fetchPunchData(userCode, month);
    }
  };


  const renderEventContent = (eventInfo) => {
    const { punchINTime, punchOUTTime, shiftName } = eventInfo.event.extendedProps;
    return (
      <div style={{
        backgroundColor: eventInfo.backgroundColor,
        color: eventInfo.textColor,
        padding: '2px',
        borderRadius: '4px',
        fontSize: '9px',
        lineHeight: '1.3',
        minHeight: '40px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',   // 👈 horizontal center
        justifyContent: 'center', // 👈 vertical center
        textAlign: 'center'     // 👈 align multiple lines center
      }}>
        <div>{eventInfo.event.title}</div>
        {/* {shiftName && <div>Shift: {shiftName}</div>} */}
        {(punchINTime || punchOUTTime) && (
          <div>({punchINTime || '--'} - {punchOUTTime || '--'})</div>
        )}
      </div>
    );
  };
  const { setLoading } = useLoading();

  const handleExecute = async () => {
    try {
      if (userCode != '') {
        setLoading(true);
        const response = await EmployeeProcessService.ExecutProcedure(userCode);
        if (response.data.statusCode === 200) {
          alert("✅ Procedure executed successfully!");
        } else {
          alert("⚠️ Failed to execute procedure!");
        }
      }
      else {
        alert('Please select Employee');
      }
    } catch (error) {
      alert("❌ An error occurred while executing the procedure.");
    } finally {
      setLoading(false);
    }
  };

  const clearDashboardData = () => {
    setWorkingHours({
      expected: "0 HH",
      actual: "0 HH",
      deducted: "0 HH"
    });

    setAttendanceStats({
      present: 0,
      paidLeave: 0,
      weeklyOff: 0,
      holidays: 0,
      absent: 0,
      unpaidLeave: 0,
      deductionLeave: 0,
      deductionPD: 0,
      arrears: 0,
      insentive: 0,
      totalPaidDays: 0
    });
  };

  return (
    <div className="form-group container">
      <div className="col-12 mb-1 border-bottom pb-1">
        <h4 className="text-left text-primary">Punch Calendar</h4>
      </div>
      <div className="row ">
        <div className=" position-relative col-md-6">
          <div className="input-group">
            <input
              type="text"
              className="form-control border-primary"
              placeholder="Type to search..."
              value={searchText}
              onChange={handleInputChange}
            />
          </div>

          {showSuggestions && suggestions.length > 0 && (
            <ul className="list-group position-absolute w-100 shadow" style={{ zIndex: 1000 }}>
              {suggestions.map((emp) => (
                <li
                  key={emp.employeeCode}
                  className="list-group-item list-group-item-action"
                  onClick={() => handleSelectSuggestion(emp)}
                  style={{ cursor: "pointer" }}
                >
                  {emp.employeeName} ({emp.employeeCode})
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className="col-md-4 mt-1">
          <Form.Control
            type="month"
            value={month}
            onChange={(e) => setMonth(e.target.value)}
          />
        </div>
        <div className="col-md-2 mt-1">
          <button type="submit" className="btn btn-primary" onClick={handleExecute}>
            <i className="fa fa-refresh me-2"></i>
            Refresh
          </button>
        </div>
      </div>
      {/* ================= WORKING HOURS ================= */}

      <div className="working-hours-card">

        <div className="hours-box">
          <span>Expected</span>
          <b>{workingHours.expected}</b>
        </div>

        <div className="hours-box">
          <span>Actual</span>
          <b>{workingHours.actual}</b>
        </div>

        <div className="hours-box">
          <span>Deducted</span>
          <b>{workingHours.deducted}</b>
        </div>

      </div>

      {/* ================= ATTENDANCE SUMMARY ================= */}

      <div className="summary-card">

        <div className="summary-item present">
          <b>{attendanceStats.present}</b>
          <span>Present</span>
        </div>

        <div className="summary-item leave">
          <b>{attendanceStats.paidLeave}</b>
          <span>Paid Leave</span>
        </div>

        <div className="summary-item holiday">
          <b>{attendanceStats.weeklyOff}</b>
          <span>Weekly Off</span>
        </div>

        <div className="summary-item holiday-day">
          <b>{attendanceStats.holidays}</b>
          <span>Holiday</span>
        </div>

        <div className="summary-item absent">
          <b>{attendanceStats.absent}</b>
          <span>Absent</span>
        </div>

        <div className="summary-item deduction">
          <b>{attendanceStats.unpaidLeave}</b>
          <span>Unpaid Leave</span>
        </div>
        <div className="summary-item deduction">
          <b>{attendanceStats.isSandwich}</b>
          <span>Sandwich </span>
        </div>
        <div className="summary-item deduction">
          <b>{attendanceStats.deductionLeave}</b>
          <span>Deduction (Leave)</span>
        </div>

        <div className="summary-item deduction">
          <b>{attendanceStats.deductionPD}</b>
          <span>Deduction (Paid days)</span>
        </div>

        <div className="summary-item deduction">
          <b>{attendanceStats.arrears}</b>
          <span>Arrears</span>
        </div>

        <div className="summary-item deduction">
          <b>{attendanceStats.insentive}</b>
          <span>Incentive</span>
        </div>

        <div className="summary-item holiday">
          <b>{attendanceStats.totalPaidDays}</b>
          <span>Total Paid Days</span>
        </div>

      </div>

      {/* ================= CALENDAR ================= */}
      <div className="calendar-container text-left" style={{ maxWidth: '900px' }}>



        <FullCalendar
          key={calendarKey}
          plugins={[dayGridPlugin, interactionPlugin]}
          initialView="dayGridMonth"
          initialDate={calendarDate}
          validRange={{
            start: dayjs(calendarDate).startOf('month').format('YYYY-MM-DD'),
            end: dayjs(calendarDate).endOf('month').add(1, 'day').format('YYYY-MM-DD')
          }}
          events={events}
          dateClick={handleDateClick}
          eventContent={renderEventContent}
          headerToolbar={{ left: '', center: 'title', right: '' }}
          height="auto"
        />


        <div className="leave-balance" style={{ marginTop: "10px" }}>

          <h6>Leave Balance</h6>

          {leaveBalance.map((l, i) => (

            <p key={i}>
              {l.leaveCode} : <b>{l.totalBalance}</b>
            </p>

          ))}

        </div>
      </div>

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: '13px', textAlign: 'center' }}>
            Punch Details - {selectedDate}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ fontSize: '11px', lineHeight: '1.4' }}>

          <p><strong>Shift:</strong> {shiftName}    | <strong>Punch Status:</strong> {statusN}</p>
          <p><strong>System Punch In:</strong> {systemIn}</p>
          <p><strong>System Punch Out:</strong> {systemOut}</p>

          <Form.Group className="mb-2">
            <Form.Label>Updated Punch In</Form.Label>
            <Form.Control
              type="time"
              step="1"
              value={inTime}
              onChange={(e) => setInTime(e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-2">
            <Form.Label>Updated Punch Out</Form.Label>
            <Form.Control
              type="time"
              step="1"
              value={outTime}
              onChange={(e) => setOutTime(e.target.value)}
            />
          </Form.Group>

          {/* ✅ Comment Section Added */}
          <Form.Group className="mb-2">
            <Form.Label>Comment</Form.Label>
            <Form.Control
              as="textarea"
              rows={2}
              placeholder="Enter comment..."
              value={comment}
              onChange={(e) => setComment(e.target.value)}
            />
          </Form.Group>

        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleUpdate}>
            Update
          </Button>
        </Modal.Footer>
      </Modal>

      <style>
        {`
          .fc-daygrid-day-frame {
            cursor: pointer;
          }
          .fc-daygrid-day-frame:hover {
            background-color: #f0f8ff;
          }
        `}
      </style>
    </div>
  );
};

export default PunchCalendar;
